<template>
    <navbar style="width: 100%;height: 72px;" align="center" :style="headerStyle">
        <div class="home-search-header-mid">
            <div class="left" style="">
                <div class="title-img" style="">
                    <img src="static/img/header/head_logo.png" style="width: 50px;height: 46px;padding-top: 10px;"/>
                </div>
                <div class="title-text" style="">
                     <span>企业大数据平台</span>
                </div>
            </div>
            <div class="right" style="">
                <div class="nav-list" style="">
                    <span class="right_nav_first">咨询</span>
                    <span class="suxian"></span>
                    <span class="right_nav">产品与服务</span>
                    <span class="suxian"></span>
                    <span class="right_nav">招商加盟</span>
                    <span class="suxian"></span>
                    <span class="right_nav">登录</span>
                    <span class="suxian"></span>
                    <span class="right_nav">企业注册</span>
                </div>
            </div>
           <!-- <div class="right" :style="{display:rightDispaly}">
                <div class="nav-list" id="loginBefore" :style="{display:beforeDisplay}">
                    <div style="height: 30px;width: 70px;margin-top: 17px;border-radius: 4px;float: right;" :style="loginStyle" align="center">
                        <div  style="width: 100%;">
                            <div class="nav" style="padding-left: 19px;">
                                <a class="login" @click="modallogin = true" style="color: #ffffff">登录</a>
                                <Modal v-model="modallogin" :footer-hide="true" :show-head="false" :width="430">
                                    <login></login>
                                </Modal>
                            </div>
                            &lt;!&ndash; <div class="nav" style="margin-top: -1px">
                                 <a>/</a>
                             </div>
                             <div class="nav">
                                 <a class="reg">注册</a>
                             </div>&ndash;&gt;
                        </div>
                    </div>
                </div>
                <div class="nav-list" id="loginAfter" :style="{display:afterDisplay}" style="margin-top: 22px;">
                    <div class="nav">
                        <Dropdown class="nav-item" id="header-right-2">
                            <a class="login">
                                             <span slot="button">
                                             <span class="d-md-down-none" id="login" style="font-size: 16px">{{loginInfo}}</span>
                                             </span></a>
                            <Dropdown-menu slot="list">
                                <Dropdown-item>
                                    <p class="dropdown-itemp"><a @click="Logout" class="loginOut">退出登录</a></p>
                                </Dropdown-item>
                            </Dropdown-menu>
                        </Dropdown>
                    </div>
                </div>
            </div>-->
        </div>

    </navbar>

</template>
<script>

    import navbar from './Navbar'
    import Cookies from 'js-cookie';
    import Login from '../../views/login/index';
    import store from '../../store';

    export default {
        name: 'header',
        data() {
            return {
                username: Cookies.get('SET_NAME'),
                modallogin: false,
                loginInfo: "登录",
                rightDispaly: "block",
                beforeDisplay: "block",
                afterDisplay: "none",
                select:{},
                headerStyle:{
                    backgroundColor:"#ffffff",
                    paddingLeft:window.innerWidth>1000?(window.innerWidth-990)*0.5+"px":"10px"
                },
                loginStyle:{
                    backgroundColor:"#3276fc",
                    marginRight:window.innerWidth>980?"0px":"10px"
                },
                logoUrl:"static/img/header/head_logo.png",
                headerLeftDisplay:window.innerWidth>654?"block":"none",
                loginPaddingLeft:window.innerWidth>980?"0px":"10px;",
                headerImgWidth:"auto",
            }
        },
        components: {
            navbar, Login
        },
        mounted() {
            this.setLoginInfo();
            this.changeSelectState();
            this.initSelectState();
        },
        created() {
            window.addEventListener('scroll', this.handleScroll, true);
            window.addEventListener('resize', this.handleResize, true);
            // 在页面加载时读取sessionStorage里的状态信息
            if (sessionStorage.getItem('store')) {
                this.$store.dispatch('setSelectState',sessionStorage.getItem("store")).then(() => {
                }).catch(err => {
                    this.$message.error(err);
                });
            }
            if (sessionStorage.getItem('word')) {
                this.$store.dispatch('setSearchWord',sessionStorage.getItem("word")).then(() => {
                }).catch(err => {
                    this.$message.error(err);
                });
            }
            window.addEventListener('beforeunload', () => {
                sessionStorage.setItem('store', store.getters.selectState);
                sessionStorage.setItem('word', store.getters.searchWord);
            })
        },
        computed: {
            listenstage(){
                return store.getters.selectState;
            }
        },
        watch: {
            listenstage:function(ov, nv) {
                this.changeSelectState(ov,nv);
            }
        },
        methods: {
            goOther(path){
                this.$router.push({path:'/'+path});
            },
            handleResize(){
                this.changeStyle();
                this.headerLeftDisplay = window.innerWidth>654?"block":"none";
                /*  this.headerImgWidth = window.innerWidth>654?"auto":window.innerWidth+"px";*/
            },
            handleScroll() {
                this.changeStyle();
            },
            changeStyle(){
                const left = $("#header-left").find("a");
                const right_1 = $("#loginBefore").find("a");
                const id = store.getters.selectState;
                if("home" ==  store.getters.selectState){
                    const  sh = document.documentElement.scrollTop;
                    if(sh > 500){
                        $("#"+id).css("border-bottom","2px solid #ffffff");
                        this.logoUrl = "static/img/header/head_logo_1.svg";
                        this.headerStyle = {backgroundColor:"#3276fc",paddingLeft:(window.innerWidth>1000?(window.innerWidth-990)*0.5+"px":"10px")};
                        this.loginStyle = {backgroundColor:"#ffffff",marginRight:window.innerWidth>980?"0px":"10px"};
                        left.each(function(){
                            $(this).css("color","#fff");
                        });
                        right_1.each(function(){
                            $(this).css("color","#333333");
                        });
                        $("#"+id).css("color","#ffffff");
                    }else {
                        $("#"+id).css("border-bottom","2px solid #3276fc");
                        this.logoUrl = "static/img/header/head_logo.png";
                        this.headerStyle = {backgroundColor:"#ffffff",paddingLeft:(window.innerWidth>1000?(window.innerWidth-990)*0.5+"px":"10px")};
                        this.loginStyle = {backgroundColor:"#3276fc",marginRight:window.innerWidth>980?"0px":"10px"};
                        left.each(function(){
                            $(this).css("color","#333333");
                        });
                        right_1.each(function(){
                            $(this).css("color","#fff");
                        });
                        $("#"+id).css("color","#3276fc");
                    }
                }else {
                    this.headerStyle = {backgroundColor:"#3276fc",paddingLeft:(window.innerWidth>1000?(window.innerWidth-990)*0.5+"px":"10px")};
                    this.loginStyle = {backgroundColor:"#ffffff",marginRight:window.innerWidth>980?"0px":"10px"};
                }
            },
            initSelectState() {
                const id = store.getters.selectState;
                $("#"+id).addClass("active");
                $("#"+id).css("color","#3276fc");
            },
            changeSelectState(ov,nv) {
                $("#"+nv).removeClass("active");
                $("#"+ov).addClass("active");

                const left = $("#header-left").find("a");
                const right_1 = $("#loginBefore").find("a");
                if(ov != undefined){
                    if(ov != "home"){
                        $("#"+ov).css("border-bottom","2px solid #ffffff");
                        $("#"+nv).css("border-bottom","");
                        this.headerStyle = {backgroundColor:"#3276fc",paddingLeft:(window.innerWidth>1200?(window.innerWidth-1190)*0.5+"px":"10px")};
                        this.loginStyle = {backgroundColor:"#ffffff",marginRight:window.innerWidth>1180?"0px":"10px"};
                        this.logoUrl = "static/img/header/head_logo_1.svg";
                        left.each(function(){
                            $(this).css("color","#fff");
                        });
                        right_1.each(function(){
                            $(this).css("color","#333333");
                        });
                        $("#"+ov).css("color","#ffffff");
                    }else {
                        $("#"+ov).css("border-bottom","2px solid #3276fc");
                        $("#"+nv).css("border-bottom","");
                        this.headerStyle = {backgroundColor:"#ffffff",paddingLeft:(window.innerWidth>1200?(window.innerWidth-1190)*0.5+"px":"10px")};
                        this.loginStyle = {backgroundColor:"#3276fc",marginRight:window.innerWidth>1180?"0px":"10px"};
                        this.logoUrl = "static/img/header/head_logo.png";
                        left.each(function(){
                            $(this).css("color","#333333");
                        });
                        right_1.each(function(){
                            $(this).css("color","#fff");
                        });
                        $("#"+ov).css("color","#3276fc");
                    }
                }
            },
            click() {
                // do nothing
            },
            sidebarToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-hidden')
            },
            sidebarMinimize(e) {
                e.preventDefault();
                document.body.classList.toggle('sidebar-minimized')
            },
            mobileSidebarToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('sidebar-mobile-show')
            },
            asideToggle(e) {
                e.preventDefault()
                document.body.classList.toggle('aside-menu-hidden')
            },
            goLogin() {
                this.$store.dispatch('FedLogOut').then(() => {
                    this.$router.push({path: '/home'});
                }).catch(err => {
                    this.$message.error(err);
                });
            },
            setLoginInfo() {
                let token = Cookies.get('Admin-Token');
                let username = Cookies.get('SET_NAME');
                if (token == "" || token == null || token == undefined) {
                    this.beforeDisplay = "block";
                    this.afterDisplay = "none";
                } else {
                    $("#login").html(username);
                    this.beforeDisplay = "none";
                    this.afterDisplay = "block";
                }
            },
            Logout(e) {
                e.preventDefault();
                this.$store.dispatch('LogOut').then(() => {
                    this.beforeDisplay = "block";
                    this.afterDisplay = "none";
                }).catch(err => {
                    this.$message.error(err);
                });
            },
        }
    }
</script>

<style type="text/css" scoped>
    .app-header.navbar {
        border-bottom: none;
    }

    .header-fixed .app-header {
        position: relative;
    }

    .app-header.navbar .navbar-brand {
        border-bottom: none;
    }

    #head-ul >>> .nav-link {
        padding-top: 18px;
    }

    .header-nav {
        width: 30px;
        height: 14px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 21px;
        letter-spacing: 1px;
        color: #ffffff;
        margin-top: 10px;
    }

    .header-button {
        width: 34px;
        height: 15px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 21px;
        letter-spacing: 1px;
        color: #ffffff;
    }

    .app-header.navbar .nav-item {
        margin-left: 25px !important;
    }

    .dropdown-itemp {
        text-align: left;
        font-size: 15px;
        padding: 10px;
    }

    .header-item .ivu-dropdown-item {
        padding: 15px;
    }

    .header-item {
        width: 100px;
        /*background-color: #20a8d8;*/
        /*background-color: white;*/
        height: 55px;


    }

    .header-item a {
        color: white !important;

    }

    .nav-item {
        color: #ffffff;
    }

    .app-header.navbar .navbar-brand {
        background-image: url("/static/img/header/head_logo.png");
        background-size: 55px 35px;
    }

    .home-search-header-mid {
        width: 980px;
        height: 72px;
    }

    .home-search-header-mid .left {
        width: 50%;
        float: left;
        height: 100%;
    }

    .home-search-header-mid .left .title-img {
        height: 100%;
        width: 80px;
        float: left;
    }
    .home-search-header-mid .left .title-text {
        height: 100%;
        width: 125px;
        float: left;
        padding: 19px 0;
        margin-left: 0;
    }
    .home-search-header-mid .left .title-text span{
        font-size: 17px;
    }
    .home-search-header-mid .left .nav-list {
        width: 90%;
        float: left;
        height: 60px;
        padding-left: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .home-search-header-mid .left .nav-list .nav {
        width: 100px;
        height: 60px;
        float: left;
        padding: 20px 0px;
    }

    .home-search-header-mid .left .nav-list .nav a {
        width: 40px;
        height: 30px;
        font-size: 16px;
        font-stretch: normal;
        line-height: 21px;
        letter-spacing: 1px;
        color: #333333;
        font-family: MicrosoftYaHei;
        font-weight: bolder;
        text-align: center;
    }

    .home-search-header-mid .left .nav-list .nav .home {
        width: 30px;
        color: #ffffff;
    }

    .home-search-header-mid .left .nav-list .nav .active {
        border-bottom: 2px solid #3276fc;
    }

    .home-search-header-mid .right {
        width: 50%;
        float: left;
        height: 100%;
    }

    .home-search-header-mid .right .nav-list {
        width: 410px;
        height: 100%;
        float: right;
        overflow: hidden;
        text-overflow: ellipsis;
        padding-left: 0;
    }

    .home-search-header-mid .right .nav-list .right_nav_first {
        font-size: 13px;
        display: inline-block;
        padding-top: 26px;
        padding-left: 56px;
        padding-right: 10px;
    }

    .home-search-header-mid .right .nav-list .right_nav {
        cursor: pointer;
        color: black;
        font-size: 13px;
        display: inline-block;
        padding-top: 26px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .home-search-header-mid .right .nav-list .suxian {
        display: inline-block;
        border-right: 1px solid #bac2c8;
        width: 1px;
        height: 14px;
    }
    .home-search-header-mid .right .nav-list div .nav a {
        height: 15px;
        font-family: MicrosoftYaHei;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 21px;
        letter-spacing: 1px;
        color: #ffffff;
    }

    .loginOut {
        color: #333333 !important;
        font-size: 14px !important;
    }


</style>



// WEBPACK FOOTER //
// Header.vue?a40b1b2a